/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { HTTP_METHOD } from "@nf/constants";
import { httpService } from "../../../../services";
import { IParticipantSearchListModel } from "../models/Participant";

export class PeopleService {
  get url(): string {
    return "/v3";
  }

  public search = async (
    pageSize: number = 30,
    pageNumber: number = 1,
    query?: string,
    sort?: string
  ): Promise<IParticipantSearchListModel> => {
    const params = {
      pageSize,
      pageNumber,
      query,
      sort,
      fieldSet: "ALL",
    };

    return httpService.request<IParticipantSearchListModel>({
      axiosConfig: {
        params,
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/content/search/participant/query/${query}`,
    });
  };
}
